import { FC } from 'react'
import { Outlet } from 'react-router'

/**
 * Root page for subscription flow process with outlet for subpages.
 * 
 * @example
 * <SubscriptionFlowPage />
 */
export const SubscriptionFlowPage: FC = () => {

  return (
    <div className='page'>
      <div className='page-content'>
        <Outlet />
      </div>
    </div>
  )
}
